"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderReactReduxAndTranslation = void 0;
const tslib_1 = require("tslib");
const hypernova = require("@as/hypernova");
const reduxAndTranslation_rendererClient_1 = require("./reduxAndTranslation.rendererClient");
const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));
const renderReactReduxAndTranslation = (reactComponent, storeConfigurator, numeralInstance, i18nTranslationResources, dynamicStore, i18nInstance, loggerInstance) => {
    return hypernova({
        server() {
            return (hypernovaRenderData) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                const renderer = yield Promise.resolve().then(() => require(
                /* webpackMode: "lazy", webpackChunkName: "hypernova_renderer_server" */ './reduxAndTranslation.rendererServer'));
                return yield renderer.default(hypernovaRenderData, reactComponent, storeConfigurator, i18nTranslationResources, numeralInstance, i18nInstance, loggerInstance);
            });
        },
        client() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const payloads = hypernova.load(reactComponent.componentName);
                if (payloads && payloads.filter(Boolean).length > 0) {
                    for (const payload of payloads) {
                        const { node, data } = payload;
                        if (node) {
                            const hypernovaRenderData = data;
                            yield (0, reduxAndTranslation_rendererClient_1.reduxAndTranslationRenderClient)(hypernovaRenderData, node, reactComponent, storeConfigurator, numeralInstance, dynamicStore, i18nTranslationResources);
                            yield wait(5);
                        }
                    }
                }
                return reactComponent;
            });
        },
    });
};
exports.renderReactReduxAndTranslation = renderReactReduxAndTranslation;
//# sourceMappingURL=reduxAndTranslation.renderer.js.map